export default "__VITE_ASSET__Ddh_ZeOA__"